import React from "react";
import MarketingPage from "@/components/MarketingPage";

export default function UseCaseMedicalStudents() {
  return (
    <MarketingPage
      testid="usecase-medical-students"
      tag="for med & nursing students"
      h1="Study Decks for Medical and Nursing Students"
      intro="Medicine and nursing bury you in reading — thick textbooks, lecture handouts, clinical guidelines and drug charts. Loom turns that mountain of PDFs into horizontal study decks with AI summaries and quizzes, so you can cover more in less time and actually retain it for exams and the wards."
      ctaText="Turn my notes into decks"
      sections={[
        {
          h2: "Built for heavy medical reading workloads",
          body: [
            "Few courses demand as much reading as medicine and nursing. Between anatomy, physiology, pharmacology, pathology and endless clinical notes, there is simply more material than hours in the day. Loom helps by slicing each dense PDF — a textbook chapter, a lecture deck, a set of guidelines — into focused study sections you can finish one at a time instead of facing a 400-page document whole.",
            "Each section becomes a card with a clear summary and the high-yield points highlighted, so you spend your energy learning mechanisms and management rather than hunting for the important lines buried in a wall of text.",
          ],
        },
        {
          h2: "Quiz yourself on high-yield facts",
          body: [
            "Active recall is the backbone of effective medical revision, and Loom builds it in. From any uploaded PDF it generates flashcards, multiple-choice questions and recall prompts grounded in your own material — ideal for memorising drug doses, differentials, normal values and step-by-step clinical protocols.",
            "Because questions come straight from your notes and guidelines, you revise exactly what your course and placements expect, with page references back to the source whenever you need to double-check a detail.",
          ],
        },
        {
          h2: "From lecture to ward, ready in minutes",
          body: [
            "Upload PDFs up to 1000 pages, walk the horizontal deck between lectures or on a break, and export any deck or quiz to PDF or PowerPoint to review offline or share with your study group. Start free, turn your first set of notes into study decks with no card required, and upgrade when you want unlimited decks for the whole semester.",
          ],
        },
      ]}
    />
  );
}
